import { render, staticRenderFns } from "./emailcompose.vue?vue&type=template&id=195ab835&scoped=true"
import script from "./emailcompose.vue?vue&type=script&lang=js"
export * from "./emailcompose.vue?vue&type=script&lang=js"
import style0 from "./emailcompose.vue?vue&type=style&index=0&id=195ab835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ab835",
  null
  
)

export default component.exports